<template>
    <v-layout row wrap>
        <v-flex xs12 s12 md12>
                <p class="headline">Comments</p>
                <hr>
        </v-flex>

        <v-flex xs12 s12 md12 v-for="(comment, index) in comments" v-bind:key="index">
            <v-card>
                <v-card-title primary-title>
                    <div>
                        <div class="title" v-html="comment.text"></div>
                        <span class="grey--text">By {{ comment.user_name }} at {{ comment.at }}</span>
                    </div>
                </v-card-title>
            </v-card>
        </v-flex>

        <v-flex xs12 s12 md12>
            <form v-on:submit.prevent="postComment">
                <ckeditor type="classic" v-model="comment" :config="markdownConfig"></ckeditor>
                <v-btn color="primary" :loading="loading" type="submit">Post comment</v-btn>
            </form>
        </v-flex>

    </v-layout>
</template>

<script>
    export default {
        props: ['sample'],
        data : function() {
            return {
                error : false,
                message_error : null,
                comments: null,
                comment: null,
                loading: false
            }
        },
        created: function () {
            if (this.sample) {
                this.getComments();
            }
        },
        watch: {
            sample: function (val) {
                this.getComments();
            },
        },
        methods: {
            getComments () {
                this.$store.dispatch('getSampleOrderComments', {
                    id: this.sample.id
                }).then((res) => {

                    this.comments = res.data.data;

                }).catch((error) => {

                });
            },
            postComment() {
                this.loading = true;
                this.$store.dispatch('postSampleOrderComment', {
                    id: this.sample.id,
                    text: this.comment
                }).then((res) => {
                    this.comment = null;
                    this.getComments();
                    this.loading = false;
                }).catch((error) => {

                });
            }
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/samples/views/components/CommentComponent.vue